import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Note({ variant = "info", className, ...rest }) {
    return (_jsx("div", { className: cn("fwfa-note", variant !== "info" && `fwfa-note--${variant}`, className), ...rest }));
}
//# sourceMappingURL=Note.js.map